import {
  Divider,
  Grid,
  Tooltip
} from "@mui/material"
import TextFieldChips from "../../../../src/utils/reusables/TextFieldChips"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
import { useTranslation } from "react-i18next"
import {
  getEmailText,
  getNotificationText
} from "./ReportFileDestinationHelper"
import { getTranslations } from "src/utils/helper"
import { Translates } from "src/i18n/i18n"
import InfoIcon from "@mui/icons-material/Info"
import shortid from "shortid"
const NotificationEmail = ({
  form,
  setChips,
  isValid,
  setIsValid
}) => {
  const { t } = useTranslation<any>()
  return (
    <Grid
      container
      data-testid="reportings-prompt-display-grid"
      className="custom-table-responsive categories-table"
    >
      <Grid item xs={12} sm={12}>
        <Divider className="dashed my-4" />
        <h4 className="my-3 text-uppercase">{getNotificationText(t)}</h4>
        <Grid container>
          <Grid item xs={12} className="mt-3">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={3}>
                <label className="mb-1 f-600">{getEmailText(t)}</label>
                <Tooltip
                  id="emailTooltip"
                  arrow
                  title={
                    <div className="pa-2">
                      <h6 className="mb-2 f-600 text-uppercase">
                        <InfoIcon className="primary-text mr-1" />
                        {getTranslations(t, Translates.Email_Address)}
                      </h6>

                      {getTranslations(t, Translates.Email_Address).split("\n").map((line, index) => (
                        <div className="mb-1" key={shortid.generate()}>
                          {line}
                        </div>
                      ))}
                    </div>
                  }
                >
                  <InfoOutlinedIcon className="primary-text ml-1" />
                </Tooltip>
                <TextFieldChips
                  getChips={setChips}
                  form={form}
                  isValid={isValid}
                  setIsValid={setIsValid}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default NotificationEmail
